/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsBranch } from "../../entities/models/Branch";
import { z } from "zod/v4";

export const modelsBranchSchema = z.object({
    "address": z.optional(z.string()),
"company_id": z.optional(z.int()),
"created_at": z.optional(z.string()),
"id": z.optional(z.int()),
"name": z.optional(z.string()),
"phone": z.optional(z.string()),
"status": z.optional(z.string()),
"timezone": z.optional(z.string()),
"updated_at": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsBranch>